import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LayoutContext } from '../../contexts/layout.context';
import { useNavigate } from 'react-router-dom';
import Button from '../../common/Buttons/Button';
import { authSelectors } from '../../store/selectors/auth';
import { getUserInfoThunk } from '../../store/thunks/profile';
import usePreviewFeature from '../../hooks/usePreviewFeature';
import PaymentResultV2 from './PaymentResultV2';
import failedImage from '../../img/payment/payment-failed.webp';

const PaymentFailed = () => {
  const { setLayout } = useContext(LayoutContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = useSelector(authSelectors).token;
  const isV2 = usePreviewFeature('cabinet-v2');

  useEffect(() => {
    document.title = 'Оплата | New Brain';
    setLayout({ page: 'Оплата' });
  }, [setLayout]);

  useEffect(() => {
    if (token) {
      dispatch(getUserInfoThunk({ token }));
    }
  }, [token]);

  useEffect(() => {
    if (isV2) {
      return undefined;
    }

    let time = 2;
    const timer = setInterval(() => {
      if (time === 0) {
        navigate('/');
      }
      --time;
    }, 1000);

    return () => clearInterval(timer);
  }, [isV2]);

  const handlePage = () => {
    navigate('/');
  };

  const hasInvoice = (() => {
    try {
      return Boolean(JSON.parse(localStorage.getItem('invoice_id')));
    } catch (e) {
      return false;
    }
  })();

  if (isV2) {
    return (
      <PaymentResultV2
        tone="failed"
        image={failedImage}
        title="Оплата не пройшла"
        text="Не хвилюйтеся — це можна швидко виправити."
        primary={{ label: 'Спробувати ще раз', onClick: () => navigate(hasInvoice ? '/finance/accounts/pay' : '/finance/accounts') }}
        secondary={{ label: 'Обрати інший спосіб', onClick: () => navigate('/finance/accounts') }}
      />
    );
  }

  return (
    <div className='finances-message container'>
      <div className="finances__message finances__message--red">
        На жаль, оплата не успішна (( <br></br>
        Не здавайтеся, спробуйте ще раз або оберіть інший спосіб!
      </div>

      <div className="finances__btn">
        <Button buttonBg="violet" onClick={handlePage} >Далі</Button>
      </div>
    </div>
  );
};

export default PaymentFailed;